import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { NumberInputControl } from "@cloudpivot/form/src/common/controls/input-controls/number-input-control";
import numberFilter from "@cloudpivot/form/utils/number-filter";
import PcInputNumber from './pc-input-number.vue';
import { H3Field } from 'h3-mobile-vue';
let MobileInputNumber = class MobileInputNumber extends NumberInputControl {
    constructor() {
        super(...arguments);
        this.value = '';
        this.hasValue = false;
    }
    get showClear() {
        return !this.readonly && this.hasValue;
    }
    onFocus() {
        this.onChange();
    }
    onBlur(evt) {
        this.$emit('blur', evt);
    }
    onChange() {
        const _ctrl = this.ctrl;
        this.hasValue = _ctrl.hasValue;
    }
    destroyed() {
        super.destroyed();
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    }
};
MobileInputNumber = tslib_1.__decorate([
    Component({
        name: "input-number",
        components: {
            PcInputNumber,
            H3Field
        },
        filters: {
            number: numberFilter
        }
    })
], MobileInputNumber);
export default MobileInputNumber;
